import humps from 'humps'
import Api from '@/api'

export default {
  fetchModelPortfolios(query) {
    return Api.get(`/portfolio_builder/portfolio_templates`, { params: humps.decamelizeKeys(query) })
  },
  fetchModelPortfolioById(modelPortfolioId) {
    return Api.get(`/portfolio_builder/portfolio_templates/${modelPortfolioId}`)
  },
  updateModelPortfolioById(modelPortfolioId, payload) {
    return Api.put(`/portfolio_builder/portfolio_templates/${modelPortfolioId}`, payload)
  }
}
